import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { NbAuthService } from '@nebular/auth';
import { take, takeWhile } from 'rxjs/operators';
import { DistintoAmbientalModel } from 'src/app/core/models/distintivo-ambiental.model';
import { DocumentoModel } from 'src/app/core/models/documento.model';
import { ImagenDocumentoModel } from 'src/app/core/models/imagen-documento.model';
import { SectorModel } from 'src/app/core/models/sector.model';
import { TipoCombustibleModel } from 'src/app/core/models/tipo-combustible.model';
import { TipoDocumentoModel } from 'src/app/core/models/tipo-documento.model';
import { TipoPlazaModel } from 'src/app/core/models/tipo-plaza.model';
import { TipoVehiculoModel } from 'src/app/core/models/tipo-vehiculo.model';
import { UsoVehiculoModel } from 'src/app/core/models/uso-vehiculo.model';
import { UsuarioAutorizadoVehiculoModel } from 'src/app/core/models/usuario-autorizado-vehiculo.model';
import { VehiculoModel } from 'src/app/core/models/vehiculo.model';
import { DocumentoService } from 'src/app/core/services/documento.service';
import { DistintivoAmbientalService } from 'src/app/core/services/maestras/distintivo-ambiental.service';
import { SectorService } from 'src/app/core/services/maestras/sector.service';
import { TipoCombustibleService } from 'src/app/core/services/maestras/tipo-combustible.service';
import { TipoDocumentoService } from 'src/app/core/services/maestras/tipo-documento.service';
import { TipoPlazaService } from 'src/app/core/services/maestras/tipo-plaza.service';
import { TipoVehiculoService } from 'src/app/core/services/maestras/tipo-vehiculo.service';
import { UsoVehiculoService } from 'src/app/core/services/maestras/uso-vehiculo.service';
import { UsuarioAutorizadoService } from 'src/app/core/services/usuario-autorizado.service';
import { VehiculosService } from 'src/app/core/services/vehiculos.service';
import { environment } from 'src/environments/environment';
import { BaseComponent } from '../area-privada/components/base/base.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'dum-vehiculo-edit-movil',
  templateUrl: './vehiculo-edit-movil.component.html',
  styleUrls: ['./vehiculo-edit-movil.component.scss']
})
export class VehiculoEditMovilComponent extends BaseComponent implements OnInit {

  idVehiculo: number;
  token: string;
  vehiculo: VehiculoModel;
  tipoVehiculos: TipoVehiculoModel[] = [];
  distintivosAmbientales: DistintoAmbientalModel[] = [];
  clasificacionVehiculos: TipoPlazaModel[] = [];
  tiposCombustible: TipoCombustibleModel[] = [];
  usosVehiculos: UsoVehiculoModel[] = [];
  sectores: SectorModel[] = [];
  alive: boolean = true;
  mensajeErrorMatricula: boolean = false;
  newDniUsuarioAutorizado: string;
  listUsuariosAuth: any[] = [];
  loadingAutorizados: boolean = true;
  documentos: DocumentoModel[] = [];
  colsUsuariosAutorizados = [
    { field: 'dni', header: 'DNI', type: 'string' },
  ];
  visibleAddDocumento: boolean = false;
  selectTiposDocumentos: TipoDocumentoModel[] = [];
  tipoDocumentoNewDocumento: TipoDocumentoModel;
  fechaVencimientoNewDocumento: Date;
  localeCalendar = environment.calendar_locale.es;
  minDate: Date = new Date();
  acceptTypeDocument: string = environment.accepts_type_documents;
  newDocumentos: File[] = [];
  tiposDocumentos: TipoDocumentoModel[] = [];
  sinPermiso: boolean = false;
  constructor(
    protected activatedRoute: ActivatedRoute,
    protected vehiculoService: VehiculosService,
    protected tipoVehiculoService: TipoVehiculoService,
    protected distintivoAmbientalesService: DistintivoAmbientalService,
    protected tiposCombustibleService: TipoCombustibleService,
    protected tipoPlazaService: TipoPlazaService,
    protected usoVehiculoService: UsoVehiculoService,
    protected sectorService: SectorService,
    protected usuarioAutorizadoService: UsuarioAutorizadoService,
    protected documentoService: DocumentoService,
    protected tipoDocumentoService: TipoDocumentoService,
    protected translateService: TranslateService
  ) {
    super();
    this.activatedRoute.params.subscribe((params: ParamMap) => {
      // tslint:disable-next-line: no-string-literal
      this.token = params['token'];
      const appToken = {
        name: 'nb:auth:JWT:token',
        ownerStrategyName: 'email',
        value: this.token
      };
      localStorage.setItem('auth_app_token', JSON.stringify(appToken));
      this.initData();
      // tslint:disable-next-line: no-string-literal
      if (params['id'] !== null && params['id'] !== 'nuevo') {
        // tslint:disable-next-line: no-string-literal
        this.idVehiculo = parseInt(params['id'], 10);
        this.vehiculoService.getVehiculoMe(this.idVehiculo)
          .pipe(take(1))
          .subscribe((vehiculo) => {
            this.vehiculo = vehiculo;
            this.getDocumentos();
            this.getUsuariosAutorizados();
          }, (error) => {
            console.log(error);
            if (error.status === 403) {
              console.log('pasa por aqui');
              this.sinPermiso = true;
            }
          });
        // tslint:disable-next-line: no-string-literal
      } else if (params['id'] === 'nuevo') {
        this.vehiculo = new VehiculoModel();
      }
    });
  }

  ngOnInit(): void {
  }

  validadorMatricula() {
    const expreg = /[0-9][0-9][0-9][0-9][a-z A-Z+][a-z A-Z+][a-z A-Z+]$/;
    if (expreg.test(this.vehiculo.matricula)) {
      this.mensajeErrorMatricula = false;
      return true;
    } else {
      this.mensajeErrorMatricula = true;
      return false;
    }
  }

  initData() {

    this.tipoVehiculoService.getAll()
      .pipe(takeWhile(() => this.alive))
      .subscribe((tiposVehiculos) => this.tipoVehiculos = tiposVehiculos);

    this.distintivoAmbientalesService.getAll()
      .pipe(takeWhile(() => this.alive))
      .subscribe((distintivosAmbientales) => this.distintivosAmbientales = distintivosAmbientales);

    this.tipoPlazaService.getAll()
      .pipe(takeWhile(() => this.alive))
      .subscribe((tiposPlaza) => this.clasificacionVehiculos = tiposPlaza);

    this.tiposCombustibleService.getAll()
      .pipe(takeWhile(() => this.alive))
      .subscribe((tiposCombustible) => this.tiposCombustible = tiposCombustible);

    this.usoVehiculoService.getAll()
      .pipe(takeWhile(() => this.alive))
      .subscribe((usosVehiculo) => this.usosVehiculos = usosVehiculo);

    this.sectorService.getAll()
      .pipe(takeWhile(() => this.alive))
      .subscribe((sectores) => this.sectores = sectores);

    this.tipoDocumentoService.getAll()
      .pipe(takeWhile(() => this.alive))
      .subscribe((tiposDocumentos) => this.tiposDocumentos = tiposDocumentos);
  }

  autorizarUsuarioVehiculo() {
    const newAutorizacion = new UsuarioAutorizadoVehiculoModel();
    newAutorizacion.nif = this.newDniUsuarioAutorizado;
    newAutorizacion.vehiculo = this.vehiculo;
    this.usuarioAutorizadoService.autorizarPersona(newAutorizacion)
      .pipe(take(1))
      .subscribe((usuarioAutorizadoDevuelto) => {
        this.listUsuariosAuth.push({ dni: newAutorizacion.nif });
        this.dumToast.add({ severity: 'success', summary: this.translateService.instant('AUTORIZACION.USUARIO.VEHICULO'), detail: this.translateService.instant('AUTORIZACION.USUARIO.VEHICULO.MSG.CONFIRMACION') });
      },
        (error) => {
          this.dumToast.add({ severity: 'error', summary: this.translateService.instant('AUTORIZACION.USUARIO.VEHICULO'), detail: error.error.message });
        });
  }

  deleteUsuarioAutorizado(dni) {
    const usuarioAutorizado: UsuarioAutorizadoVehiculoModel = new UsuarioAutorizadoVehiculoModel();
    usuarioAutorizado.nif = dni.dni;
    usuarioAutorizado.vehiculo = this.vehiculo;
    this.usuarioAutorizadoService.eliminarAutorizado(usuarioAutorizado)
      .pipe(take(1))
      .subscribe(() => {
        this.listUsuariosAuth.splice(this.listUsuariosAuth.indexOf(dni), 1);
        this.dumToast.add({ severity: 'success', summary: this.translateService.instant('AUTORIZACION.USUARIO.VEHICULO'), detail: this.translateService.instant('AUTORIZACION.ELIMINACION.USUARIO.VEHICULO.MSG.CONFIRMACION') });

      }, (error) => {
        this.dumToast.add({ severity: 'error', summary: this.translateService.instant('AUTORIZACION.USUARIO.VEHICULO'), detail: error.error.message });
      });
  }

  getUsuariosAutorizados() {
    this.usuarioAutorizadoService.findAutorizadosByIdVehiculos(this.vehiculo.id)
      .pipe(takeWhile(() => this.alive))
      .subscribe((listaDNI) => {
        listaDNI.forEach((nDni) => this.listUsuariosAuth.push({ dni: nDni }));
        this.loadingAutorizados = false;
      });
  }

  resetearVariablesAddDocumentos() {
    this.newDocumentos[this.tipoDocumentoNewDocumento.nombre] = [];
    this.fechaVencimientoNewDocumento = undefined;
  }

  saveNewDocumento() {
    const fechaVencimiento = this.fechaVencimientoNewDocumento !== undefined ? `${this.fechaVencimientoNewDocumento.getDate()}/${this.fechaVencimientoNewDocumento.getMonth() + 1}/${this.fechaVencimientoNewDocumento.getUTCFullYear()}` : undefined;
    this.documentoService.saveDocumento(this.vehiculo.id, fechaVencimiento, this.tipoDocumentoNewDocumento.id, this.newDocumentos)
      .pipe(take(1))
      .subscribe((newDocumento) => {
        newDocumento.tipoDocumento = this.tipoDocumentoNewDocumento;
        this.visibleAddDocumento = false;
        this.fechaVencimientoNewDocumento = undefined;
        this.tipoDocumentoNewDocumento = undefined;
        this.newDocumentos = [];
        this.documentos.push(newDocumento);
      });
  }

  addNewDocumento(event) {
    this.newDocumentos = [];
    this.newDocumentos = event.currentFiles;
  }

  cancelNewDocumento() {
    this.resetearVariablesAddDocumentos();
  }

  deleteDocumento(documento: DocumentoModel) {
    this.documentoService.delete(documento.id)
      .pipe(take(1))
      .subscribe((resultInfo) => {
        this.dumToast.add({ severity: 'success', summary: this.translateService.instant('DOCUMENTO.ELIMINACION'), detail: `${this.translateService.instant('DOCUMENTO.MSG.ELIMINACION')} ${documento.tipoDocumento.nombre}` });
        this.documentos.splice(this.documentos.indexOf(documento), 1);
      },
        (error) => {
          this.dumToast.add({ severity: 'error', summary: this.translateService.instant('DOCUMENTO.ELIMINACION'), detail: `${this.translateService.instant('DOCUMENTO.MSG.ELIMINACION.ERROR')} ${error.error.message}` });
        });
  }


  downloadDocument(imagen: ImagenDocumentoModel) {
    this.documentoService.getImagenesDocumentos(imagen.id)
      .pipe(take(1))
      .subscribe((img) => {

        const fileUrl = window.URL.createObjectURL(img);
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(img, imagen.nombre);
        } else {
          window.open(fileUrl);
        }
      });
  }

  saveVehiculo() {
    if (this.vehiculo.id) {
      this.vehiculoService.updateMeVehiculo(this.vehiculo)
        .pipe(takeWhile(() => this.alive))
        .subscribe((vehiculo) => {
          this.vehiculo = vehiculo;
          this.dumToast.add({ severity: 'success', summary: this.translateService.instant('VEHICULO.ACTUALIZACION'), detail: `${this.translateService.instant('VEHICULO.ACTUALIZACION.MSG.CORRECTO')} ${vehiculo.matricula}` });
        },
          (error) => {
            this.dumToast.add(
              { severity: 'error', summary: this.translateService.instant('VEHICULO.ACTUALIZACION'), detail: `${this.translateService.instant('VEHICULO.ACTUALIZACION.MSG.ERROR')} ${this.vehiculo.matricula}, ${error.error.message}` });
          });
    } else {
      this.vehiculoService.save(this.vehiculo)
        .pipe(takeWhile(() => this.alive))
        .subscribe((vehiculo) => {
          this.vehiculo = vehiculo;
          this.dumToast.add({ severity: 'success', summary: this.translateService.instant('VEHICULO.ACTUALIZACION'), detail: `${this.translateService.instant('VEHICULO.ACTUALIZACION.MSG.CORRECTO')} ${vehiculo.matricula}` });
        },
          (error) => {
            this.dumToast.add(
              { severity: 'error', summary: this.translateService.instant('VEHICULO.ACTUALIZACION'), detail: `${this.translateService.instant('VEHICULO.ACTUALIZACION.MSG.ERROR')} ${this.vehiculo.matricula}, ${error.error.message}` });
          });
    }

  }

  addDocumento() {
    this.selectTiposDocumentos = this.tiposDocumentos.filter((tipo) => {
      let existTipo = false;
      this.documentos.forEach((documento) => {
        if (tipo.id === documento.tipoDocumento.id) {
          existTipo = true;
        }
      });
      return !existTipo;
    });
    if (this.selectTiposDocumentos.length > 0) {
      this.newDocumentos = [];
      this.visibleAddDocumento = true;
    } else {
    }
  }

  /**
   * Obtención de todos los documentos que tiene el vehiculo.
   * @param {number} id
   * @memberof VehiculoDetailComponent
   */
  getDocumentos() {
    this.documentoService.findByVehiculoMe(this.vehiculo.id)
      .pipe(takeWhile(() => this.alive))
      .subscribe((documentos) => {
        this.documentos = documentos;
      });
  }

  /**
   * función para obtener el color de fondo dependiendo del estado.(vehiculo/documento)
   * @param {*} idEstado
   * @returns
   * @memberof VehiculoDetailComponent
   */
  getBgColorEstado(idEstado) {
    switch (idEstado) {
      case 1:
        return '#FDDDA4';
      case 2:
        return '#C9E6CB';
      case 3:
        return '#FECBD2';
    }
  }

  /**
   * función para obtener el color del texto dependiendo del estado.(vehiculo/documento)
   * @param {*} idEstado
   * @returns
   * @memberof VehiculoDetailComponent
   */
  getTextColorEstado(idEstado) {
    switch (idEstado) {
      case 1:
        return '#6D5100';
      case 2:
        return '#224A23';
      case 3:
        return '#73000C';
    }
  }
}
